import { render, staticRenderFns } from "./MemberChallengesArchiveTable.vue?vue&type=template&id=4fecaf2f&scoped=true&lang=pug&"
import script from "./MemberChallengesArchiveTable.vue?vue&type=script&lang=js&"
export * from "./MemberChallengesArchiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecaf2f",
  null
  
)

export default component.exports